import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';

export default function SettingsWhatsAppTab({ restaurantInfo, setRestaurantInfo, handleSave }) {
  return (
    <Card className="border-border/40">
      <CardHeader>
        <CardTitle style={{ fontFamily: 'Outfit, sans-serif' }}>WhatsApp Numbers</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Customer WhatsApp Number</Label>
          <Input
            placeholder="+1234567890"
            value={restaurantInfo.whatsapp_number}
            onChange={(e) => setRestaurantInfo({ ...restaurantInfo, whatsapp_number: e.target.value })}
            data-testid="wa-number"
          />
        </div>
        <div>
          <Label>Kitchen WhatsApp Number</Label>
          <Input
            placeholder="+1234567890"
            value={restaurantInfo.kitchen_whatsapp_number}
            onChange={(e) => setRestaurantInfo({ ...restaurantInfo, kitchen_whatsapp_number: e.target.value })}
            data-testid="wa-kitchen-number"
          />
        </div>
        <p className="text-sm text-muted-foreground" style={{ fontFamily: 'Figtree, sans-serif' }}>
          💡 Kitchen number receives order notifications. Customer number is shown to your customers for inquiries.
        </p>
        <Button onClick={() => handleSave('restaurant')} style={{ backgroundColor: '#E57200' }} data-testid="save-wa-btn">
          Save
        </Button>
      </CardContent>
    </Card>
  );
}
